exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-autocomplete .autocomplete {\n  padding: 0;\n}\n.inline-autocomplete input {\n  border: thin solid #666;\n  /*font-size: 1.2em;*/\n  border-radius: 3px;\n  padding: 8px !important;\n  background-color: #fff;\n  background-image: none;\n  /*padding-left: 50px !important;*/\n}\n.inline-autocomplete input:disabled {\n  background-color: #f8f8f8;\n  border-color: #e0e0e0;\n}", ""]);

// exports
